<hr class="upperline" />

<div class="my-account-form-container terra-error-style">
  <form [formGroup]="pageForm" (ngSubmit)="save()" (keydown.enter)="$event.preventDefault()">
    <div class="form-grid">

      <!-- First Name -->
      <div class="terra-form-field-wrapper">
        <label for="txtFirstName" class="text-input-label">First name</label>
        <mat-form-field appearance="outline">
          <input matInput id="txtFirstName" formControlName="firstName" autocomplete="first-name" class="lo_sensitive" />
          <mat-error *ngIf="pageForm.get('firstName').hasError('required')"> Required </mat-error>
          <mat-error *ngIf="pageForm.get('firstName').hasError('minlength')">First name must be more than one character</mat-error>
        </mat-form-field>
      </div>

      <!-- Last Name -->
      <div class="terra-form-field-wrapper">
        <label for="txtLastName" class="text-input-label">Last name</label>
        <mat-form-field appearance="outline">
          <input matInput id="txtLastName" formControlName="lastName" autocomplete="last-name" class="lo_sensitive" />
          <mat-error *ngIf="pageForm.get('lastName').hasError('required')"> Required </mat-error>
          <mat-error *ngIf="pageForm.get('lastName').hasError('minlength')">Last name must be more than one character</mat-error>
        </mat-form-field>
      </div>

      <!-- Phone number -->
      <terra-phone formControlName="phone1">
        <label for="txtPhone" class="text-input-label">Phone</label>
      </terra-phone>

      <div class="terra-form-field-wrapper full-width">
        <i class="two-factor-notice" *ngIf="agentDetails.isTwoFactorAuthenticationEnabled">Note: Updating your phone number will turn off Two-factor Authentication until re-verified</i>
      </div>

      <!-- Error message -->
      <div *ngIf="isSubmitted" class="full-width">
        <p *ngIf="pageForm.invalid" class="error-message">
          Please review and correct the fields marked in red
        </p>
        <p *ngIf="isGeneralServerError" class="error-message">{{ generalServerErrorMessage }}</p>
      </div>

      <div class="form-actions full-width">
        <button type="submit" [disabled]="isLoading" class="page-cta half-width tall-button" color="accent" mat-flat-button>Save</button>
      </div>

      <terra-loader [centerToParent]="true" *ngIf="isLoading"></terra-loader>
    </div>
  </form>
</div>
